import shared from './core/shared';
import storageKeys from './core/storageKeys';
import storage from './core/storage';
import { SHOPLAZZA_CART_COUNTRY_PREFIX_BY_COMPANY_ID } from './core/companyIds';
import isKnownCrawlerUA, { logCrawlerHit } from './core/isKnownCrawlerUA';
import { oneidInit } from './core/oneID';
import eventReportLimit from './core/eventReportLimit';
import identityGate from './core/identityGate';

// 爬虫彻底零请求早退：不建业务队列、不发 Site/Visit 等任何上报
if (isKnownCrawlerUA()) {
  logCrawlerHit();
  var __cartseeCrawlerStub = window.cartq || (window.cartq = function () {});
  __cartseeCrawlerStub.push = __cartseeCrawlerStub.push || __cartseeCrawlerStub;
  __cartseeCrawlerStub.queue = __cartseeCrawlerStub.queue || [];
  __cartseeCrawlerStub.loaded = true;
  __cartseeCrawlerStub.callMethod = function () {};
} else {

if (!window.cartq) {
  // 加载js
  !(function (w, d, u, c, e, s) {
    if (w.cartq) return;
    c = w.cartq = function () {
      c.callMethod ? c.callMethod.apply(c, arguments) : c.queue.push(arguments);
    };
    if (!w._cartq) w._cartq = c;
    c.push = c;
    c.loaded = !0;
    c.version = '1.0';
    c.queue = [];
    // e = d.createElement('script');
    // e.async = !0;
    // e.src = u;
    // s = d.getElementsByTagName('script')[0];
    // s.parentNode.insertBefore(e, s)
  })(window, document);

  // 优先从当前执行脚本取店铺 id，避免页面删除 script 标签后遍历不到
  const currentScriptSrc = document.currentScript?.src || document.currentScript?.getAttribute('data-src') || '';
  let cartElSrc = /\/carttrack-shoplazza-test.js?/.test(currentScriptSrc) ? currentScriptSrc : '';
  if (!cartElSrc) {
    for (let el of document.getElementsByTagName('script')) {
      if (/\/carttrack-shoplazza-test.js?/.test(el.src)) {
        cartElSrc = el.src;
        break;
      }
    }
  }
  const companyID = (cartElSrc.match(new RegExp('id=([^&]+)')) || [])[1];
  cartq('init', companyID);

  if (window.SHOPLAZZA?.customer) {
    cartq('set', 'customer', {
      id: window.SHOPLAZZA.customer.customer_id,
      email: window.SHOPLAZZA.customer.customer_email,
      phone: window.SHOPLAZZA.customer.customer_phone
    });
  } else {
    cartq(
      'set',
      'customer',
      storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {})
    );
  }
}

!(function (w, c, u) {

  u = 'https://59b517704ce43f0f.cartseekite.com/cartxtrack';
  c = w.cartq;
  c.params = {};

  const LS_DEBUG = storageKeys.DEBUG;
  const LS_CHECKOUT_EMAIL = storageKeys.CX_CHECKOUT_EMAIL;
  function cartx_debug(...args) {
    if (storage.getLocal(LS_DEBUG)?.includes('cartsee:')) {
      console.log('%ccartsee:carttrack', 'color: #513EFF', ...args);
    }
  }

  const BEHAVIOR_VISIT_PAGE_EVENT = 'Site/VisitPage';
  const behaviorTrackBridgeEventTypes = ['Site/Visit', 'Site/ViewProduct', BEHAVIOR_VISIT_PAGE_EVENT, 'Cart/Add'];
  const normalizeBehaviorPageKey = (value) => {
    let normalized = String(value || location.pathname || '/');
    try {
      normalized = new URL(normalized, location.origin).pathname;
    } catch (e) {
      normalized = normalized.split(/[?#]/)[0];
    }
    normalized = normalized
      .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '')
      .replace(/\+?\d[\d\s().-]{7,}\d/g, '')
      .replace(/\/$/, '');
    return (normalized || '/').slice(0, 128);
  };
  const sanitizeBehaviorScalar = (value) => normalizeBehaviorPageKey(value).replace(/^\//, '');
  const inferBehaviorCollectionId = (payloadData = {}, pathname = location.pathname || '/') => {
    if (payloadData.collectionId !== undefined && payloadData.collectionId !== null) {
      return sanitizeBehaviorScalar(payloadData.collectionId);
    }
    const match = normalizeBehaviorPageKey(payloadData.pageKey || payloadData.pathName || pathname).match(/^\/collections\/([^/]+)/);
    return match?.[1] ? sanitizeBehaviorScalar(match[1]) : '';
  };
  const inferBehaviorPageData = (eventType, payloadData = {}) => {
    if (eventType === 'Cart/Add') {
      return {};
    }
    const pathname = location.pathname || '/';
    const pageType = payloadData.pageType ||
      (eventType === 'Site/ViewProduct' || pathname.includes('/products') ? 'product_detail'
        : pathname.includes('/collections') ? 'collection'
          : pathname === '/' ? 'home'
            : '');
    if (!pageType) return null;
    const data = {
      pageType,
      pageKey: normalizeBehaviorPageKey(payloadData.pageKey || payloadData.pathName || pathname)
    };
    if (payloadData.productId !== undefined && payloadData.productId !== null) {
      data.productId = sanitizeBehaviorScalar(payloadData.productId);
    }
    if (pageType === 'collection') {
      const collectionId = inferBehaviorCollectionId(payloadData, pathname);
      if (collectionId) data.collectionId = collectionId;
    }
    return data;
  };
  const dispatchBehaviorTrackBridge = (eventType, payloadData = {}, timestamp) => {
    if (!behaviorTrackBridgeEventTypes.includes(eventType)) {
      return;
    }
    const isCartAdd = eventType === 'Cart/Add';
    const behaviorData = inferBehaviorPageData(eventType, payloadData);
    if (!isCartAdd && !behaviorData) {
      return;
    }
    // 行为弹窗只需要页面类型和稳定对象标识，桥内禁止透传埋点原始 payload，避免敏感字段进入前端状态。
    const detail = {
      eventType: isCartAdd ? 'Cart/Add' : BEHAVIOR_VISIT_PAGE_EVENT,
      timestamp: timestamp || Date.now(),
      companyId: String(c.id || ''),
      data: behaviorData || {}
    };
    try {
      window.__cartseeBehaviorTrackLastEvent = detail;
    } catch (e) {
    }
    if (window.__cartseeBehaviorTrackBridgeEnabled !== true) {
      return;
    }
    try {
      window.dispatchEvent(new CustomEvent('cartq/track', { detail }));
    } catch (e) {
      cartx_debug('cartq/track dispatch failed', e);
    }
  };

  if (window.SHOPLAZZA?.customer) {
    c.params.customer = {
      email: window.SHOPLAZZA?.customer?.customer_email,
      phone: window.SHOPLAZZA?.customer?.customer_phone
    };
    cartx_debug(c.params.customer, 'c.params.customerc.params.customer');
  } else {
  }
  // 兜底的监听方式
  document.addEventListener('dj.viewContent', function (e) {
    c.params.product = e?.detail?.product;
    cartx_debug(e?.detail?.product, 'e?.detail?.product-2');
    cartx_debug(c.params.product, 'c.params.product-2');
    // 针对店匠dj.viewContent 事件在 Site/ViewProduct触发后才触发导致拿不到值的情况
    if (location.pathname.indexOf('/products') !== -1) {
      // 浏览商品Viewed Product: 用户进入集成站点product详情页
      c('track', 'Site/ViewProduct', {
        email:
          c.params?.customer?.email ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
          '',
        phone:
          c.params?.customer?.phone ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).phone ||
          '',
        pathName: location.href,
        productId: String(c.params?.product?.id || ''),
        productName: c.params?.product?.title || '',
        price: c.params?.product?.price || null,
        compareAtPrice: c.params?.product?.compare_at_price || ''
      });
    }
  });

  // 获取其他商户弹窗的email信息
  window.addEventListener('message', function (message) {
    const dataStr = JSON.stringify(message?.data ?? {});
    const obj = JSON.parse(dataStr);
    const resultEmail = checkEmailInObj(obj);
    if (resultEmail) {
      cartx_debug('抓到第一个email', resultEmail);
      storage.setLocal(storageKeys.CARTX_EMAIL, resultEmail);
      cartq('set', 'customer', {
        id: window.SHOPLAZZA.customer.customer_id,
        email:
          window.SHOPLAZZA.customer.customer_email ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
          '',
        phone: window.SHOPLAZZA.customer.customer_phone
      });
    }
  });
  function checkEmailInObj(obj) {
    if (!obj) {
      return null;
    }
    let email = null;
    const pn = Object.getOwnPropertyNames(obj) ?? [];
    for (let i = 0; i < pn.length; i++) {
      const name = pn[i];
      const value = obj[name] ?? '';
      if (typeof value === 'string') {
        // 检查name是否包含email
        // if (name == "email" || name == "e") {
        // 检查value
        if (isEmail(value)) {
          // console.log('抓到邮箱为：', value);
          return value;
        }
        // }
      } else if (typeof value === 'object') {
        email = checkEmailInObj(value);
        if (email) {
          return email;
        }
      }
    }
    return email;
  }
  function isEmail(strEmail) {
    if (strEmail.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
      return true;
    } else {
      return false;
    }
  }

  function getCountryCode() {
    const prefix = SHOPLAZZA_CART_COUNTRY_PREFIX_BY_COMPANY_ID[c?.id];
    if (prefix) {
      return '/' + prefix;
    }
    if (window.SHOPLAZZA?.routes?.root) {
      return window.SHOPLAZZA?.routes?.root.replace(/\/$/, '');
    }
    return '';
  }

  function getNextData() {
    if (window.__NEXT_DATA__) {
      cartx_debug('获取页面数据', window.__NEXT_DATA__);
      return window.__NEXT_DATA__;
    }

    const elem = document.querySelector('#__NEXT_DATA__');
    if (elem) {
      try {
        const data = JSON.parse(elem.textContent);
        cartx_debug('获取页面数据', data);
        return data;
      } catch (e) {
        cartx_debug('解析页面数据失败', e);
      }
    }
    return null;
  }

  c.helper = {
    ...shared,
    getCart: function (fn) {
      c.helper.ajax.get(
        {
          url: location.origin + getCountryCode() + '/api/cart?promoter=cartrack'
        },
        function (res) {
          res && (c.params.cart = res.cart);
          fn && fn();
        }
      );
    },
    getProduct: function (fn) {
      if (c.params.product) {
        cartx_debug(c.params.product, '有c.params.product');
        fn && fn();
      } else if (window.opt?.product && !c.params.product) {
        cartx_debug('有window.opt?.product');
        c.params.product = window.opt?.product;
        fn && fn();
      }
    },
    handleAddCart: function () {
      if (storage.getSession(storageKeys.CARTTRACK_ADD_CARD) === 'false') {
        c('track', 'Cart/Add', {
          email:
            c.params?.customer?.email ||
            storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
            '',
          phone:
            c.params?.customer?.phone ||
            storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).phone ||
            '',
          pathName: location.href,
          productId: String(c.params?.product?.id || ''),
          productName: c.params?.product?.title || '',
          price: c.params?.product?.price || null,
          compareAtPrice: c.params?.product?.compare_at_price || '',
          variantId: storage.getSession(storageKeys.CARTTRACK_VARIANT_ID) || null,
          cartToken: c.helper.getCookie('_identity_cart') || '', // 购物车token
          cartJson: c.params?.cart || null // 购物车
        });
        storage.setSession(storageKeys.CARTTRACK_ADD_CARD, 'true');
      }
    },
    getCustomerId: function () {
      return window.SHOPLAZZA?.customer?.customer_id || '';
    }
  };

  c.eventList = {
    init: function (e, id, email) {
      c.id = Number(id);
      if (c.id) {
        storage.setLocal(storageKeys.CARTX_COMPANY_ID, String(c.id));
      }
      cartx_debug('init', { e, id, email });
      c.params = { ...c.params, customer: { ...c.params?.customer, email: email } };
    },
    set: function (e, key, value) {
      c.params = { ...c.params, [key]: value };
    },
    track: function (e, v, d = {}) {
      if (isKnownCrawlerUA()) {
        return;
      }

      if (v === 'Cart/Add') {
        storage.setLocal(storageKeys.CARTX_CART, JSON.stringify(d));
      }

      // 邮件到站cid
      const cid =
        c.helper.getQueryVariable('cid') || storage.getLocal(storageKeys.CARTX_CID) || null;
      // 登录用户id
      const customerId = String(c.params?.customer?.id || c?.helper?.getCustomerId() || '');

      const cartseeNewsletterEmail =
        storage.getLocal(storageKeys.CARTSEE_NEWSLETTER_EMAIL) || '';
      cartx_debug(`cartseeNewsletterEmail=${cartseeNewsletterEmail} customerId=${customerId} cid=${cid}`);
      if (cartseeNewsletterEmail && !customerId && !cid) {
        // 优先级最低
        d.email = d.email || cartseeNewsletterEmail;
        if (v === 'Checkout/Create') {
          d.customer.email = d.customer.email || cartseeNewsletterEmail;
        }
      }

      const p = {
        uid:
          storage.getLocal(storageKeys.CARTSEE_UID) || c.helper.getCookie('_c_id'), // 唯一用户标识
        requestId: c.helper.guid(), // 每次request的uuid
        timestamp: Date.now(),
        eventType: v,
        companyId: c.id || '',
        integrationId: 21,
        clientTimezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || null,
        cid,
        oid: storage.getLocal(storageKeys.CARTSEE_ONEID) || null,
        customerId, // shopify用户id，在已登录情形下才会有
        data: d
      };
      cartx_debug('上报埋点', p);

      dispatchBehaviorTrackBridge(v, d, p.timestamp);

      // if ([2848, 2766, 1812, 2438, 2459, 1560, 2603, 896, 1001, 1523].includes(c?.id)) {
        u = 'https://59b517704ce43f0f.ctxcollect.com/cartxtrack';
      // }

      identityGate.allow(v, p).then(function (ok) {
        if (!ok) {
          cartx_debug('identity blocked', v);
          return;
        }
        if (!eventReportLimit.canReport(
          v,
          p.companyId,
          {
            email: d?.email || c.params?.customer?.email || '',
            phone: d?.phone || c.params?.customer?.phone || '',
            customerId: p.customerId,
            uid: p.uid,
            oid: p.oid
          },
          d?.pathName || location.href
        )) {
          cartx_debug('event report limited', v);
          return;
        }
        c.helper.ajax.post({
          url: u,
          contentType: 'application/json',
          data: JSON.stringify(p)
        });
      });
    }
  };

  if (c.helper.getQueryVariable('cid')) {
    storage.setLocal(storageKeys.CARTX_CID, c.helper.getQueryVariable('cid'));
  }

  c.callMethod = function () {
    if (arguments.length === 0 || !Object.keys(c.eventList).includes(arguments[0])) return console.warn('no event');
    c.eventList[arguments[0]].apply(c, arguments);
  };
  c.queue.forEach(function (a) {
    c.apply(c, a);
  });
  c.queue = [];

  const isHitCartPageReport = true;
  const isHitCheckoutReport = true;
  const isHitCheckoutCarts = true;
  cartx_debug('exps', {
    isHitCartPageReport,
    isHitCheckoutReport,
    isHitCheckoutCarts
  });

  // 站点活跃Active on Site: 用户进入站点任意页面
  c('track', 'Site/Visit', {
    pathName: location.href,
    email:
      c.params?.customer?.email ||
      storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
      '',
    phone:
      c.params?.customer?.phone ||
      storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).phone ||
      ''
  });

  c.helper.getCart(null);

  if (location.pathname.indexOf('/products') !== -1) {
    c.helper.getProduct(function () {
      // 浏览商品Viewed Product: 用户进入集成站点product详情页
      c('track', 'Site/ViewProduct', {
        email:
          c.params?.customer?.email ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
          '',
        phone:
          c.params?.customer?.phone ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).phone ||
          '',
        pathName: location.href,
        productId: String(c.params?.product?.id || ''),
        productName: c.params?.product?.title || '',
        price: c.params?.product?.price || null,
        compareAtPrice: c.params?.product?.compare_at_price || ''
      });
    });
  }

  c.listenAdd = function () {
    if (document.readyState === 'complete') {
      const button = document.getElementsByTagName('button');
      const input = document.getElementsByTagName('input');
      c.handleEle(button);
      c.handleEle(input);
    }
  };

  c.handleEle = function (elements) {
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const name = element.getAttribute('name');
      const type = element.getAttribute('type');
      const cssClass = element.getAttribute('class');
      const id = element.getAttribute('id');
      if (
        (id && id.toLowerCase().indexOf('addtocart') !== -1) ||
        (id && id.indexOf('add_to_cart') !== -1) ||
        (id && id.indexOf('add-to-cart') !== -1) ||
        (cssClass && cssClass.toLowerCase().indexOf('addtocart') !== -1) ||
        (cssClass && cssClass.indexOf('add_to_cart') !== -1) ||
        (cssClass && cssClass.indexOf('add-to-cart') !== -1) ||
        (name && name === 'add' && type && type === 'submit')
      ) {
        element.addEventListener('click', c.listenerEvent);
      }
    }
  };

  c.listenerEvent = function () {
    storage.setSession(storageKeys.CARTTRACK_ADD_CARD, 'false');
    storage.setSession(
      storageKeys.CARTTRACK_VARIANT_ID,
      c.helper.getQueryVariable('variant') || c.params?.product?.variants?.[0]?.id || ''
    );
    let times = 0;
    const fn = function () {
      times += 1;
      if (c?.params?.cart?.item_count) {
        cartx_debug('通过点击加购按钮触发加购');
        c.helper.handleAddCart();
      } else if (times < 10) {
        setTimeout(() => {
          c.helper.getCart(fn);
        }, 2000);
      }
    };
    c.helper.getCart(fn);
  };

  // base64解码
  function base64Decode(encodedString) {
    // 使用atob函数进行解码
    var decodedString = atob(encodedString);
    return decodedString;
  }

  // 定义一个用于发送请求的函数
  function sendRequest(params) {
    const url = location.origin + '/api/cart/batch';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params),
      credentials: 'include' // 包含cookie信息
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
  }

  // 用于存储所有请求的Promise数组
  const requestPromises = [];
  if (location.pathname.indexOf('/cart') !== -1) {
    if (location.href.includes('cartsee_skus')) {
      c.helper.getCart(function () {
        const params = new URLSearchParams(location.search).get('cartsee_skus');
        cartx_debug('recover cart cartsee_skus params', params);
        const decodedString = base64Decode(params);
        try {
          const decodedArr = JSON.parse(decodedString);
          // 1. 用 Map 存储当前购物车商品
          const cartItems = new Map();
          c.params?.cart?.line_items?.forEach((item) => {
            cartItems.set(item.variant_id, true);
          });
          cartx_debug('current cart', cartItems);

          // 2. 过滤需要添加的商品
          const resultParam = decodedArr.reduce((acc, item) => {
            // 如果商品不在购物车中,则添加到结果数组
            if (!cartItems.has(item.variant_id)) {
              acc.push({
                product_id: item.product_id,
                variant_id: item.variant_id,
                quantity: item.quantity
              });
            }
            return acc;
          }, []);

          // 3. 请求api加购
          if (resultParam.length > 0) {
            sendRequest({
              line_items: resultParam
            }).then((res) => {
              cartx_debug('recover cart success', resultParam);
              window.location.href = location.origin + '/cart';
            });
          } else {
            cartx_debug('recover cart not has diff variant_id');
          }
        } catch (error) {
          cartx_debug('recover cart error', error);
        }
      });
    }
  }

  if (location.pathname.indexOf('/cart') !== -1) {
    if (isHitCartPageReport) {
      storage.setSession(storageKeys.CARTTRACK_ADD_CARD, 'false');
    }
    c.helper.getCart(c.helper.handleAddCart);
  }

  // 不带参数的checkout页面 或者参数step=contact_information
  const isCheckoutPage =
    location.pathname.includes('/checkout') &&
    (c.helper.getQueryVariable('step') === '' || c.helper.getQueryVariable('step') === 'contact_information') &&
    c.helper.getQueryVariable('payFailCode') === '';
  // 排除下单感谢和下单处理页面
  const isCheckoutSuccess = isCheckoutPage && (location.pathname.includes('/thank_you') || location.pathname.includes('/processing') || location.pathname.includes('/express/callback'));
  let hasSendCheckoutCreate = false;
  if (isCheckoutPage && !isCheckoutSuccess && isHitCheckoutReport) {
    cartx_debug('进入checkout流程', isCheckoutPage);
    function collectionForm(selector) {
      const ret = {};
      const container = selector ? document.querySelector(selector) : document;

      const inputs = container?.querySelectorAll('input');
      inputs?.forEach((item) => {
        const name = item.getAttribute('name') || item.getAttribute('id');
        if (!ret[name]) {
          ret[name] = item.value || item._value || '';
        }
      });
      const selects = container?.querySelectorAll('select');
      selects?.forEach((item) => {
        const name = item.getAttribute('name') || item.getAttribute('id');
        if (!ret[name]) {
          ret[name] = item.value || item._value || '';
        }
      });

      // 拼装信息待分割
      ['payment-address-contact', 'payment-address-ship-to', 'payment-address-ship-content', 'payment-address-info'].map((key) => {
        const elem = container?.querySelector(`[data-robot="${key}"]`);
        ret[key] = elem?.innerText || '';
      });

      cartx_debug('collectionForm', ret);
      return ret;
    }

    /**
     * address
     * address1
     * address1-autofill
     * address-autofill
     * city
     * city-autofill
     * countryCode-autofill
     * coupon-mobile
     * coupon-pc
     * email
     * firstName
     * firstName-autofill
     * lastName
     * lastName-autofill
     * phone
     * provinceCode-autofill
     * zip
     * zip-autofill
     */
    function collectionInfo(args) {
      let ret = collectionForm();

      const orderType = c.helper.getQueryVariable('orderType');
      const customer = storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {});
      cartx_debug('customer', customer);
      const cart =
        orderType === 'BuyNow'
          ? storage.getLocalJSON(storageKeys.CARTX_CART_BUY_NOW, {})
          : storage.getLocalJSON(storageKeys.CARTX_CART, {});
      const time = new Date().toISOString();
      const email = ret.email || ret['payment-address-contact'] || customer.email;
      const phone = ret.phone || customer.phone;
      const checkoutToken = location.pathname.split('/').slice(-1)?.[0];
      cartx_debug('checkoutToken', checkoutToken);
      const {
        address: address1 = '',
        address1: address2 = '',
        city: city = '',
        country: country = '',
        firstName: firstName = '',
        lastName: lastName = '',
        province: province = '',
        zip: zip = ''
      } = ret;

      let lineItems = cart.cartJson?.line_items?.map((item) => ({
        compareAtPrice: item.compare_at_price,
        price: item.price,
        line_price: item.line_price,
        productId: item.product_id,
        quantity: item.quantity,
        sku: item.sku,
        title: item.product_title,
        variantId: item.variant_id,
        variantTitle: item.variant_title
      }));
      let totalPrice = 0;
      let totalWeight = 0;

      if (isHitCheckoutCarts) {
        const nextData = getNextData();
        const checkout = nextData?.props?.pageProps?.checkoutPageData?.checkout;

        if (checkout) {
          lineItems = checkout.order?.lineItems.map((item) => ({
            compareAtPrice: item.originPrice,
            price: item.finalPrice,
            line_price: item.finalLinePrice,
            productId: item.productId,
            quantity: item.quantity,
            sku: item.sku,
            title: item.productTitle,
            variantId: item.variantId,
            variantTitle: item.variantTitle
          }));
          totalPrice = checkout.order.total;
          totalWeight = checkout.order.lineItems.reduce((acc, item) => acc + item.weight, 0);
        }
      }

      const ans = {
        abandonedCheckoutUrl: location.href,
        cartToken: cart.cartToken,
        checkoutId: '',
        orderId: '',
        checkoutToken: checkoutToken || '',
        closedAt: time,
        completedAt: time,
        createdAt: time,
        updatedAt: time,
        currency: cart.cartJson?.currency,
        name: '',
        totalPrice,
        totalWeight: null,
        billingAddress: {
          address1,
          address2,
          city,
          company: '',
          country,
          countryCode: '',
          firstName,
          lastName,
          phone,
          province,
          provinceCode: '',
          zip
        },
        customer: {
          customerId: '',
          email,
          firstName,
          lastName,
          phone
        },
        lineItems
      };

      return { ...ans, ...args };
    }

    function trackCheckoutCreate(data) {
      const prevEmail = storage.getLocal(LS_CHECKOUT_EMAIL);
      if (!hasSendCheckoutCreate) {
        hasSendCheckoutCreate = true;
        c('track', 'Checkout/Create', data);
      } else if (data?.customer?.email && isEmail(data?.customer?.email) && (!hasSendCheckoutCreate || prevEmail !== data?.customer?.email)) {
        hasSendCheckoutCreate = true;
        storage.setLocal(LS_CHECKOUT_EMAIL, data?.customer?.email);
        c('track', 'Checkout/Create', data);
      }
    }

    function debounce(func, wait) {
      let timeout;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          func.apply(context, args);
        }, wait);
      };
    }

    function checkoutCreate() {
      const createdAt = new Date().toISOString();
      const data = collectionInfo({
        createdAt
      });
      trackCheckoutCreate(data);

      const handleBlur = debounce(function () {
        cartx_debug('email blur');
        const data = collectionInfo({
          createdAt,
          updatedAt: new Date().toISOString()
        });
        trackCheckoutCreate(data);
      }, 300);

      const email = document.querySelector('input[type=email]');
      cartx_debug('email', email);
      email?.addEventListener('blur', handleBlur);
    }

    try {
      checkoutCreate();
      setTimeout(checkoutCreate, 1000);
    } catch (e) {
      cartx_debug('checkoutCreate error', e);
    }
  }

  // 默认事件获取
  c.listenAdd();
  if (document.onreadystatechange) {
    const oldFn = document.onreadystatechange;
    document.onreadystatechange = function (...args) {
      oldFn(...args);
      c.listenAdd();
    };
  } else {
    document.onreadystatechange = c.listenAdd;
  }

  c.listenAddToCart = () => {
    if (!document) {
      return;
    }
    document.addEventListener('dj.addToCart', (e) => {
      storage.setSession(storageKeys.CARTTRACK_ADD_CARD, 'false');
      storage.setSession(
        storageKeys.CARTTRACK_VARIANT_ID,
        c.helper.getQueryVariable('variant') || c.params?.product?.variants?.[0]?.id || ''
      );
      cartx_debug('通过dj.addToCart事件触发加购', e);
      c.helper.getCart(c.helper.handleAddCart);
    });
  };
  if (window?.document) {
    c.listenAddToCart();
  } else {
    setTimeout(() => {
      c.listenAddToCart();
    }, 500);
  }

  const receiveMessage = (e) => {
    if (e?.data && typeof e?.data === 'string' && e?.data === '_cartsee_send') {
      // 重新上报
      // 站点活跃Active on Site: 用户进入站点任意页面
      c('track', 'Site/Visit', {
        pathName: location.href,
        email:
          c.params?.customer?.email ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).email ||
          '',
        phone:
          c.params?.customer?.phone ||
          storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {}).phone ||
          ''
      });

      // 如果是商详页
      if (location.pathname.indexOf('/products') !== -1) {
        c.helper.getProduct(function () {
          // 浏览商品Viewed Product: 用户进入集成站点product详情页
          c('track', 'Site/ViewProduct', {
            email:
              c.params?.customer?.email ||
              storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {})
                .email ||
              '',
            phone:
              c.params?.customer?.phone ||
              storage.getLocalJSON(storageKeys.CARTX_CUSTOMER, {})
                .phone ||
              '',
            pathName: location.href,
            productId: String(c.params?.product?.id || ''),
            productName: c.params?.product?.title || '',
            price: c.params?.product?.price || null,
            compareAtPrice: c.params?.product?.compare_at_price || ''
          });
        });
      }
    }
  };
  window?.addEventListener('message', receiveMessage, false);
  try {
    oneidInit();
  } catch (e) {
    console.error('oneidInit error:', e);
  }

  if (location.pathname.includes('/checkout') && location.pathname.includes('/thank_you')) {
    const { pathname, searchParams } = new URL(window.location.href);
    const arr = pathname.split('/');
    const checkoutToken = arr.length >= 2 ? arr[arr.length - 2] : '';
    const orderId = searchParams.get('orderId') || '';

    c('track', 'Checkout/Token', {
      orderId: orderId || checkoutToken,
      checkoutToken,
      url: window.location.href
    });
  }

})(window);
}
